import { Link, useLocation } from '@/libs/router'
import { tv } from '@/libs/tv'
import { useWorkflows } from '../hooks/use-workflows'

const navLink = tv({
	base: 'text-606060 text-sm',
	variants: {
		active: {
			true: 'text-primary font-medium underline underline-offset-8',
		},
	},
})

const TasksNav = () => {
	const { workflows } = useWorkflows()
	const location = useLocation()

	if (!workflows.length) return null

	return (
		<nav className='py-4'>
			<ul className='flex space-x-6 text-sm overflow-auto scrollbar-hide'>
				{workflows.map(wf => (
					<li key={wf.id}>
						<Link
							to='/tasks/$workflow-id'
							params={{ 'workflow-id': wf.id }}
							className={navLink({ active: location.pathname === `/tasks/${wf.id}` })}
						>
							{wf.name}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	)
}

export { TasksNav }
